import React from "react";
import { makeStyles } from "@material-ui/styles";
import SearchIcon from "@material-ui/icons/Search";
import { Paper, InputBase, IconButton } from "@material-ui/core";
import LocationSearchingIcon from "@material-ui/icons/LocationSearching";
var useStyles = makeStyles(function (theme) {
  return {
    inputSearch: {
      marginLeft: "0px",
      flex: "1"
    },
    root: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    iconButton: {
      padding: "6px 10px"
    }
  };
});

var InputSearch = function InputSearch(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: [classes.root, props.classes || null].join(" "),
    elevation: props.elevation || 1
  }, /*#__PURE__*/React.createElement(InputBase, {
    className: classes.inputSearch // autoFocus
    ,
    value: props.value,
    onChange: props.onChange,
    placeholder: props.placeholder || ""
  }), !props.hideButton && /*#__PURE__*/React.createElement(IconButton, null, props.location ? /*#__PURE__*/React.createElement(LocationSearchingIcon, null) : /*#__PURE__*/React.createElement(SearchIcon, null)));
};

export { InputSearch };